"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionTypeComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const RetentionTypeComponent = (props) => {
    const onClickMenu = ({ key }) => {
        props.onChange(key);
    };
    const renderInputLabel = (0, react_1.useMemo)(() => {
        switch (props.value) {
            case "nDay":
                return "N Day";
            case "nWeek":
                return "N Week";
            case "nMonth":
                return "N Month";
        }
    }, [props.value]);
    const items = (0, react_1.useMemo)(() => {
        return [
            { key: "nDay", label: "N Day" },
            { key: "nWeek", label: "N Week" },
            { key: "nMonth", label: "N Month" },
        ];
    }, []);
    const renderMenu = () => {
        return React.createElement(antd_1.Menu, { onClick: onClickMenu, items: items });
    };
    return React.createElement(antd_1.Form.Item, null,
        React.createElement(antd_1.Dropdown, { overlay: renderMenu, trigger: ["click"], disabled: false },
            React.createElement(antd_1.Button, null,
                renderInputLabel,
                " ",
                React.createElement(icons_1.DownOutlined, null))));
};
exports.RetentionTypeComponent = RetentionTypeComponent;
